import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Params } from '@angular/router';
import { FormGroup, FormArray, FormBuilder, FormControl } from '@angular/forms';
import { LocalStorageService } from 'angular-2-local-storage';
import { ModalInputEmailComponent } from '../modal-input-email/modal-input-email.component';
import { Headers, Http, Response } from '@angular/http';

import { Training } from './training';
import { Question } from './question';
import { Answer } from './answer';
import { Result } from './result';
import { Fixtures } from '../fixtures';

import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Component({
  selector: 'app-training',
  templateUrl: './training.component.html',
  styleUrls: ['./training.component.scss']
})
export class TrainingComponent implements OnInit {
    training: Training;
    result: Result;
    email: string;
    modal: any;
    public form: FormGroup;
    private apiResults = '//api.ras.universarium.org/atomemail';
    private headers = new Headers({'Content-Type': 'application/json'});

  constructor(
      private modalService: NgbModal,
      private entities: Fixtures,
      private route: ActivatedRoute,
      private _fb: FormBuilder,
      private storage: LocalStorageService,
      private http: Http
  ) {
      this.email = <string>this.storage.get('email');
  }

    ngOnInit(): void {

        this.route.params
            .switchMap((params: Params) => this.entities.tests.filter(test => {
                return test.id === params['id'];
            }))
            .subscribe((training) => {
                this.training = training;
                this.form = this._fb.group({
                    answer: this._fb.array([])
                });
            });

    }

    onChange(answer: Answer, isChecked: boolean) {
      const answerArray = <FormArray>this.form.controls.answer;

      if (isChecked) {
            answerArray.push(new FormControl(answer));
        } else {
            const index = answerArray.controls.findIndex(x => x.value === answer)
            answerArray.removeAt(index);
        }
    }

    /**
     * Calculate results
     * @param questions
     * @param answers
     */
    calculateResults(questions: Array<Question>, answers: Array<Answer>) {
        let result = 0;
        questions.forEach(question => {
            // Get question user answers
            const qAnswers = answers.filter(answer => {
                return answer.questionId === question.id;
            });
            // Get right map answers for this question
            const rightMap = question.answers.filter(answer => {
                return answer.isRight;
            });
            result += +this.compareArrays(rightMap, qAnswers);
        });

        return result;
    }

    /**
     * Compare two arrays
     * @param far
     * @param lar
     * @returns {boolean}
     */
    compareArrays(far: Array<any>, lar: Array<any>) {
        if (far.length !== lar.length) {
            return false;
        }

        let searchCounter = 0;

        far.forEach(first => {
            lar.forEach(last => {
                if (first === last) {
                    searchCounter++;
                }
            })
        });
        return searchCounter === far.length;
    }

    /**
     * getClassByPercent
     * @param success
     * @param total
     * @returns {any}
     */
    getStyleByMark(mark) {
        let style;
        switch ( mark ) {
            case 3:
                style = 'test-not-passed';
                break;
            case 2:
                style = 'test-failed';
                break;
            default:
                style = '';
                break;
        }

        return style;
    }

    calcMark(success, total) {
        if (success / total < 0.25) {
            return 2;
        }
        if (success / total < 0.75) {
            return 3;
        }
        return 5;
    }

    openMailModal() {
        this.modal.close();
        this.modalService.open(ModalInputEmailComponent, { windowClass: 'send-email' });
    }

    save(answers, content) {

        const total = this.training.questions.length,
              success = this.calculateResults(this.training.questions, answers),
              mark = this.calcMark(success, total),
              styleClass = this.getStyleByMark(mark);

        let description;

        if (this.training.id === 'entrance') {
            description = success === total
                ? 'Thank you for taking the test. Now you can turn to the lectures. At the end of the course, please take the final test to check your knowledge.'
                : 'Sorry, you did not pass the test. You can retake the test or pass on to the lectures. At the end, please take the final test to check your knowledge.'
        }


        if (this.training.id === 'final') {
            description = success === total
                ? 'Thank you for taking the test. Now you can turn to the lectures. At the end of the course, please take the final test to check your knowledge.'
                : 'Sorry, you did not pass the test. You can retake the test now or watch the lectures again and then retake the test. At the end, please take the final test to check your knowledge.'
        }

        this.result = {
            success: success,
            test: this.training.id,
            total: total,
            title: success === total ? 'Test completed' : 'Test not completed',
            answers: answers,
            mark: mark,
            description: description
        };


        if (this.storage.get('email')) {
            this.postData(this.result).subscribe();
        } else {
            this.storage.set('result', this.result);
            this.storage.set('referer', `/tests/${this.training.id}`);
        }

        this.modal = this.modalService.open(content, { windowClass: styleClass} );
    }

    postData(result: Result) {

        const body = {
            results: result,
            email: this.storage.get('email'),
            name: this.storage.get('name')
        };

        return this.http
            .post(this.apiResults, body, { headers: this.headers })
            .map((resp: Response) => resp.json())
            .catch((error: any) => { return Observable.throw(error); });
    }

}



// WEBPACK FOOTER //
// /var/www/ras.universarium.org/www/src/app/training/training.component.ts